export const checkObjectValues = (objectToCheck: any) => {
  return Object.keys(objectToCheck).map(data => objectToCheck[data]);
};
